
class ProductStickyCTA extends HTMLElement {
    private footerEl: Element | null;
    private readonly focusableSelector = 'a, button, input, select, textarea, cta-cart, [tabindex]:not([tabindex="-1"])';
    private readonly isComingSoon: boolean;

    constructor() {
      super();
      this.footerEl = document.querySelector('.footer');
      this.isComingSoon = !!document.querySelector('main-product[data-coming-soon]');
      this.bindEvents();
      this.setActiveState(false);
    }

    bindEvents() { 
       if (!this.isComingSoon) {
         const ctaButtonElement = this.querySelector("cta-cart");
         ctaButtonElement?.addEventListener("click", this.onCTAClick.bind(this));
       }

       window.addEventListener('scroll', this.enableStickyCTA.bind(this));
    }

    onCTAClick() {
        if (!this.classList.contains('active')) return;

        const trueCTAButton = document.querySelector(".product__information cta-cart") as HTMLElement;
        trueCTAButton?.click();
    }

    enableStickyCTA(event: Event) {
        const ctaElement = document.querySelector(".product__information .product__cta-group");
        const offset = ctaElement?.getBoundingClientRect().top;

        if(offset && offset < 90) {
            // Hide sticky bar when footer content is visible beneath it -- SG 20260506
            const footerTop = this.footerEl?.getBoundingClientRect().top;
            if (footerTop != null && footerTop <= window.innerHeight - 16) {
                this.setActiveState(false);
                return;
            }
            this.setActiveState(true);
        }
        else {
            this.setActiveState(false);
        }
    }

    setActiveState(isActive: boolean) {
        this.classList.toggle('active', isActive);

        if (isActive) {
            this.removeAttribute('aria-hidden');
            this.removeAttribute('inert');
        }
        else {
            this.setAttribute('aria-hidden', 'true');
            this.setAttribute('inert', '');
            if (this.contains(document.activeElement)) {
                const focusTarget = this.isComingSoon
                  ? (document.querySelector(".product__information .product__cart-cta") as HTMLElement | null)
                  : (document.querySelector(".product__information cta-cart") as HTMLElement | null);
                focusTarget?.focus?.({ preventScroll: true });
            }
        }

        this.querySelectorAll<HTMLElement>(this.focusableSelector).forEach((element) => {
            if (isActive) {
                const previousTabIndex = element.dataset.stickyCtaTabindex;
                if (previousTabIndex == null) return;

                if (previousTabIndex === '') {
                    element.removeAttribute('tabindex');
                }
                else {
                    element.setAttribute('tabindex', previousTabIndex);
                }
                delete element.dataset.stickyCtaTabindex;
                return;
            }

            if (element.dataset.stickyCtaTabindex == null) {
                element.dataset.stickyCtaTabindex = element.getAttribute('tabindex') ?? '';
            }
            element.setAttribute('tabindex', '-1');
        });
    }
  
}
  
customElements.define('product-sticky-cta', ProductStickyCTA);